import { Box, Container, Grid, Typography, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";

// Footer Component
const Footer = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Box
      sx={{
        background: "white",
        color: "black",
        mt: "auto",
        position: "sticky",
        bottom: 0,
        zIndex: 1100,
        height: "auto",
      }}
    >
      <Box
        sx={{
          padding: "0.625vw 3.75vw",
          borderTop: { xs: "1px solid #e7e7e7", md: "none" },
        }}
      >
        <Grid
          container
          spacing={4}
          sx={{
            [theme.breakpoints.down("md")]: {
              display: "block",
              justifyItems: "center",
            },
          }}
        >
          <Grid
            size={{ xs: 6, md: 6 }}
            component="div"
            sx={{
              textAlign: "left",
              [theme.breakpoints.down("md")]: {
                textAlign: "center",
                width: "100%",
              },
            }}
          >
            <Typography variant="h4" fontWeight={400}>
              ©{new Date().getFullYear()} EZIFIN Financial Services
            </Typography>
          </Grid>

          <Grid
            size={{ xs: 6, md: 6 }}
            component="div"
            sx={{
              justifyItems: "right",
              [theme.breakpoints.down("md")]: {
                justifyItems: "center",
                width: "100%",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                gap: "2rem",
                justifyContent: "right",
                [theme.breakpoints.down("md")]: {
                  gap: "5vw",
                },
              }}
            >
              <Typography variant="h4" fontWeight={400}>
                <a
                  href="/privacy-policy"
                  target="_blank"
                  className="text-underline"
                  // onClick={() => navigate("/privacy-policy")}
                >
                  Privacy Policy
                </a>
              </Typography>
              <Typography variant="h4" fontWeight={400}>
                <a
                  href="/terms-of-service"
                  target="_blank"
                  className="text-underline"
                  // onClick={() => navigate("/terms-of-service")}
                >
                  Terms of Service
                </a>
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Footer;
